export default __webpack_public_path__ + "static/media/SOLDADURABRACKETS.c5352978.webp";